// management_control 폼의 [개선필요 여부] radio → [관리 우선순위] block 토글.
// '개선 필요' (value='true') 선택 시에만 priorityTarget 을 노출.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["priority"]

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    const checked = this.element.querySelector(
      'input[name="management_control[needs_improvement]"]:checked'
    )
    const show = !!checked && checked.value === 'true'
    if (this.hasPriorityTarget) {
      this.priorityTarget.classList.toggle('hidden', !show)
    }
  }
}
